/**
 * Customer-facing form of a product SKU.
 *
 * SKUs arrive both from brands typing them and from integrations, and the
 * integration ones can carry an internal ADDRESS rather than an identifier:
 * a Shopify import lands as `SHOPIFY-gid://shopify/Product/9353532702971`, a
 * GraphQL global ID. Rendering that verbatim on a customer's certificate leaks
 * both the integration we use and its internal URI scheme onto what is meant to
 * be a luxury brand's own surface.
 *
 * So strip the provider prefix and the `gid://<host>/<type>/` envelope down to
 * the bare identifier, and leave every hand-authored SKU
 * (`OMEGA-SPEED-310.30.42.50.01.001`, `BAG-001`) exactly as the brand wrote it —
 * those are the brand's own vocabulary and are not ours to reformat.
 */
const GID_PATTERN = /^(?:[A-Za-z0-9_]+-)?gid:\/\/[^/]+\/[^/]+\/(.+)$/;

export const formatSku = (sku?: string | null): string => {
  if (!sku) return '';
  const trimmed = sku.trim();
  const gid = trimmed.match(GID_PATTERN);
  return gid ? gid[1] : trimmed;
};
